import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding } from '@alto/design-system';
import React from 'react';

export const DosagesInfoActionSheet = () => (
  <ActionSheetV2 title="Why we keep track of your dosages">
    <LgPadding topPadding={SPACING.STATIC.NONE}>
      <Body>
        It’s common for your provider to adjust your medication dosages over the course of your fertility cycle. When
        this happens, it may change the amount of medication you need. Keeping track of your dosages helps us stay on
        top of your refill needs and avoid sending extra medication you won’t use.
      </Body>
    </LgPadding>
  </ActionSheetV2>
);
